import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ColorPickerModule } from 'ngx-color-picker';
import { FnColorPickerComponent } from './fn-color-picker.component';
import { FnCoreModule } from '../../core/index';

export * from './fn-color-picker.component';

/** 
 * Exports the required FnColorPickerComponent to create Color Picker Element
 * making them available for import by NgModules that import this module.
 */
@NgModule({
    imports: [CommonModule, FormsModule, ColorPickerModule, FnCoreModule],
    declarations: [FnColorPickerComponent],
    exports: [FnColorPickerComponent]
})
export class FnColorPickerModule {

}